import { Routes } from '@angular/router';
import { CardStatusGuard } from '@core/guards/card-status';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('@features/home/pages/home/home').then(m => m.Home),
    data: {
      breadcrumb: 'HOME',
      metaDescriptionKey: 'CORE.DESCRIPTION'
    }
  },
  {
    path: 'news',
    loadChildren: () => import('@features/news/news.routes').then(m => m.NEWS_ROUTES)
  },
  {
    path: 'support',
    loadChildren: () => import('@features/support/support.routes').then(m => m.SUPPORT_ROUTES)
  },
  {
    path: 'opening-hours',
    redirectTo: 'support/opening-hours',
    pathMatch: 'full'
  },
  {
    path: 'improve-hse-card-solution',
    redirectTo: 'support/improve-hse-card-solution',
    pathMatch: 'full'
  },
  {
    path: 'legal',
    loadChildren: () => import('@features/legal/legal.routes').then(m => m.LEGAL_ROUTES)
  },
  {
    path: 'sitemap',
    redirectTo: 'legal/sitemap',
    pathMatch: 'full'
  },
  {
    path: 'privacy-and-cookies',
    redirectTo: 'legal/privacy-and-cookies',
    pathMatch: 'full'
  },
  {
    path: 'terms-of-use',
    redirectTo: 'legal/terms-of-use',
    pathMatch: 'full'
  },
  {
    path: 'check-validity',
    loadChildren: () => import('@features/card-validity/card-validity.routes').then(m => m.CARD_VALIDITY_ROUTES)
  },
  {
    path: 's/:cardId',
    loadComponent: () =>
      import('@features/card-validity/pages/check-validity/check-validity').then(m => m.CheckValidity),
    canActivate: [CardStatusGuard]
  },
  {
    path: 'v/:cardId',
    loadComponent: () =>
      import('@features/card-validity/pages/check-validity/check-validity').then(m => m.CheckValidity),
    canActivate: [CardStatusGuard]
  },
  {
    path: 'V/:cardId',
    redirectTo: 'v/:cardId'
  },
  {
    path: 'system-messages',
    loadChildren: () => import('@features/system-messages/system-messages.routes').then(m => m.SYSTEM_MESSAGES_ROUTES)
  },
  {
    path: 'for-developers',
    loadChildren: () => import('@features/developers/developers.routes').then(m => m.DEVELOPERS_ROUTES)
  },
  {
    path: 'for-utviklere',
    redirectTo: 'for-developers',
    pathMatch: 'full'
  },
  {
    path: '**',
    title: 'PAGES.PAGE-NOT-FOUND.TITLE',
    loadComponent: () => import('@core/pages/page-not-found/page-not-found').then(m => m.PageNotFound)
  }
];
